import Link from 'next/link';
import { useRouter } from 'next/router';

import qs from 'qs';

import type CategoryType from '../../types/CategoryType';

import styles from './CategoriesList.module.scss';

interface Props {
  categories: Array<CategoryType>;
  selectedCategory?: CategoryType;
}
const CategoriesList: React.FC<Props> = ({ categories, selectedCategory }) => {
  const router = useRouter();

  const params = qs.stringify({
    size: router.query.size,
    query: router.query.query,
  });

  return (
    <div className={styles.categoriesList}>
      <h3>Kategorie</h3>

      <ul>
        {categories.map((category) => (
          <li
            key={category.id}
            className={
              selectedCategory?.id === category.id
                ? styles.selectedListItem
                : ''
            }
          >
            <Link
              href={`/katalog/${category.slug}${params ? `?${params}` : ''}`}
            >
              <a>{category.name}</a>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default CategoriesList;
